import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route } from "react-router-dom";
import "semantic-ui-css/semantic.min.css";
import "./assets/css/style.css";
import "./assets/css/theme.css";
import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import decode from "jwt-decode";
import { composeWithDevTools } from "redux-devtools-extension";
import App from "./components/App";
import rootReducer from "./reducers/rootReducer";
import { userLoggedIn, userLoggedOut } from "./actions/auth";
import { getUsuario } from "./actions/usuario";
import { I18nextProvider } from "react-i18next";
import { iniciarTema } from "./utils/tema";
import i18n from "./i18n";

iniciarTema();

const store =
  process.env.NODE_ENV === "development"
    ? createStore(rootReducer, composeWithDevTools(applyMiddleware(thunk)))
    : createStore(rootReducer, applyMiddleware(thunk));

const TOKEN_KEY = process.env.REACT_APP_LOCALSTORAGE_AUTH_TOKEN;

const renderApp = () =>
  ReactDOM.render(
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <Provider store={store}>
          <Route component={App} />
        </Provider>
      </BrowserRouter>
    </I18nextProvider>,
    document.getElementById("root")
  );

const logout = () => {
  localStorage.removeItem(TOKEN_KEY);
  store.dispatch(userLoggedOut());
};

const isTokenValid = (exp) => {
  const time = new Date().getTime() * 0.001;
  return time < exp;
};

const token = localStorage[TOKEN_KEY];

if (token) {
  try {
    const payload = decode(token);
    if (isTokenValid(payload.exp)) {
      store.dispatch(getUsuario()).then((usuario) => {
        if (usuario && payload.id === usuario._id) {
          store.dispatch(userLoggedIn({ token, user: { ...usuario } }));
        } else {
          logout();
        }
        renderApp();
      });
    } else {
      logout();
      localStorage.tokenExpired = "Sua sessão expirou";
      renderApp();
    }
  } catch (err) {
    logout();
    renderApp();
  }
} else {
  renderApp();
  if (localStorage.tokenExpired) {
    localStorage.removeItem("tokenExpired");
  }
}

// registerServiceWorker();
